import React, { useState, useEffect } from "react";
import { Input, Form, Spin, Select } from "antd";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton";
import ModalComponent from "../../../components/global/modal/ModalComponent";
import LoadableButton from "../../../components/buttons/LoadableButton";
import { AddCreditTransactionApi, GetCreditInOutTransactionApi, GetUserNameByTerminalIdAdpi } from "../../../api/request/credit";
import moment from "moment";
import MyPagination from "../../../components/global/pagination/Pagination";
import toast from "react-hot-toast";
import columns from "../../../columns/Credit";
import { useSelector } from "react-redux";
const { Search } = Input;


export default function Credit() {

    const userDetails = useSelector((state) => state.user.userDetails);
    let isSalesManager = userDetails?.roleId === 6;

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isCreditOpen, setIsCreditOpen] = useState(false);
    const [isAddCreditLoading, setIsAddCreditLoading] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [tearminalId, setTearminalId] = useState(null);
    const [isEnable, setIsEnable] = useState(true)


    const options = [
        { label: 'Credit In', value: 8 },
        { label: 'Credit Out', value: 9 },
    ];

    const fetchCreditInOutTransaction = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
            }
            setIsLoading(true);
            const { data } = await GetCreditInOutTransactionApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(data?.data?.map((item) => {
                    return {
                        ...item,
                        createdDate: moment(item?.createdDate).format('DD-MM-YYYY, LT'),
                    }
                }))
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        }
        catch (error) {
            setIsLoading(false);
        }
    }

    const handleLiveAccountChange = async (terminalId) => {
        setTearminalId(terminalId);
        try {
            setIsSearchLoading(true);
            const { data } = await GetUserNameByTerminalIdAdpi(terminalId);
            if (data?.success) {
                form.setFieldsValue({ customerName: data?.data?.fullName });
                setIsEnable(false);
            }
            setIsSearchLoading(false);
        } catch (error) {
            setIsSearchLoading(false);
            toast.error(error?.response?.data?.message);
            form.resetFields();
        }
    };

    const handleSubmit = async (value) => {
        try {
            setIsAddCreditLoading(true);
            const params = {
                ...value,
                Amount: Number(value?.Amount),
                TearminalId: Number(value?.TearminalId),
                TransactionType: Number(value?.TransactionType),
            }
            delete params.customerName;
            const { data } = await AddCreditTransactionApi(params);
            if (data?.success) {
                toast.success(data?.message)
                setIsCreditOpen(false);
                form.resetFields();
                fetchCreditInOutTransaction();
            }
            setIsAddCreditLoading(false);
        }
        catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsAddCreditLoading(false);
        }
    }

    useEffect(() => {
        fetchCreditInOutTransaction();
    }, [page, pageSize]);

    useEffect(() => {
        if (!isCreditOpen) {
            form.resetFields();
        }
    }, [isCreditOpen]);

    return (
        <div>
            <div className="flex flex-col sm:flex-row sm:justify-end">
                <div className="flex">
                    {!isSalesManager && <div>
                        <button onClick={() => setIsCreditOpen(true)} className="export-btm flex bg-primary text-sm text-white font-medium uppercase px-9 py-2 rounded-lg themeHover  duration-400" size="large" >
                            <img src="assets/icons/add_icon.svg" alt="icon" className="mr-2 mt-1" width={15} />
                            Add New Credit
                        </button>
                    </div>}
                </div>
            </div>

            <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                <div className="px-4 lg:px-6">
                    <p className="text-[#2F2B3D] text-xl font-semibold">Credit In-Out <span className="primary">{isLoading ? (<Spin className="ml-2" size="small" />) : `(${totalRecord})`}</span></p>
                </div>
                <div className="mt-6 mb-6 ">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                    <MyPagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
                </div>


                {/* Add New Credit */}
                <ModalComponent isOpen={isCreditOpen} setIsOpen={setIsCreditOpen} title={<div className="font-bold text-lg">Add New Credit</div>} onCancel={() => setIsCreditOpen(false)}>
                    <Form className="w-full flex flex-col justify-center gap-3" autoComplete="off" form={form} onFinish={handleSubmit}>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">Live Account</label>
                            <Form.Item name="TearminalId" rules={[{ required: true, message: "Please enter account number" }]} >
                                <Search placeholder="input search text" value={tearminalId} enterButton="Search" size="large" loading={isSearchLoading}
                                    onSearch={handleLiveAccountChange} />
                            </Form.Item>
                        </div>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">Customer Name</label>
                            <Form.Item name="customerName">
                                <Input disabled={isEnable} readOnly placeholder="Enter customer name" className="mt-1 w-full py-2" />
                            </Form.Item>
                        </div>
                        <div className="grid sm:grid-cols-2 gap-2">
                            <div className="input-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">Amount</label>
                                <Form.Item name="Amount" rules={[
                                    { required: true, message: "Please enter amount" },
                                    { pattern: /^\d+(\.\d{1,2})?$/, message: "Please enter a valid number" },
                                ]} >
                                    <Input stringMode={false} disabled={isEnable} placeholder="Enter amount" className="mt-1 w-full py-2" />
                                </Form.Item>
                            </div>
                            <div className="ant-select-selector-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium">Credit Type</label>
                                <Form.Item name="TransactionType" rules={[{ required: true, message: "Please select credit type" }]} >
                                    <Select disabled={isEnable} placeholder="Choose An Account" className="mt-1 w-full " options={options} />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">Note</label>
                            <Form.Item name="Comment">
                                <Input disabled={isEnable} placeholder="Enter Note" className="mt-1 w-full py-2" />
                            </Form.Item>
                        </div>

                        <div className="flex justify-end mt-8">
                            <LoadableButton
                                className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
                                disabled={isAddCreditLoading}
                                type="Submit"
                                lable="Add"
                                isLoading={isAddCreditLoading}
                                loadingLable="Adding..."
                            />
                        </div>
                    </Form>
                </ModalComponent>
            </div>
        </div>
    );
}